

	import { Component, Prop, Watch } from 'vue-property-decorator';
	import { PropType } from 'vue';
	import { BaseView } from '@shared/views/BaseView';
	import { DeckColor } from '@shared/models';

	@Component({})
	export default class DeckPalette extends BaseView { 

		@Prop({ default: () => [] })
		public palette: DeckColor[];

	}

